import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AbstractControl, UntypedFormArray, UntypedFormGroup } from "@angular/forms";
import { isNil } from "lodash";
import { SharedService } from "src/app/shared/services/shared.service";

@Component({
	selector: "app-view-maneuver",
	templateUrl: "./view-maneuver.component.html",
	styleUrls: ["./view-maneuver.component.scss"],
	standalone: false,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewManeuverComponent implements OnInit {
	maneuverForm!: UntypedFormGroup;
	parentForm!: UntypedFormArray;
	parentFormArrayIndex: number = 0;
	panelOpenState: boolean = false;
	@Input() addRemoveList: any;
	@Input("maneuverForm") set _(value: any) {
		this.maneuverForm = value as UntypedFormGroup;
	}
	@Output() selectedOBList: EventEmitter<any> = new EventEmitter<any>();
	@Output() resetCurrentManeuver: EventEmitter<any> = new EventEmitter<any>();
	TS1_OB_LIST: Array<any> = [];

	constructor(public sharedService: SharedService) {
		this.TS1_OB_LIST = this.sharedService.generateSortedOBList();
	}

	ngOnInit(): void {
		this.parentForm = this.maneuverForm.parent as UntypedFormArray;
		this.parentFormArrayIndex = this.parentForm.controls.findIndex((subform) => subform == this.maneuverForm);
	}

	hasValue(key: string): boolean {
		const codeValues = this.maneuverForm.value[key];
		for (const k in codeValues) {
			if (codeValues[k].totalCount > 0) {
				return true;
			}
		}
		return false;
	}

	isRemoved(key: string, index: number, fc: AbstractControl) {
		const obDetails = this.addRemoveList[`${key}${index}`];
		return !isNil(obDetails) && obDetails.isRemoved === true;
	}

	isAdded(key: string, index: number, fc: AbstractControl) {
		const obDetails = this.addRemoveList[`${key}${index}`];
		return !isNil(obDetails) && obDetails.isOriginal === false && obDetails.isRemoved === false;
	}

	get maneuver() {
		return this.maneuverForm.get("maneuver")!;
	}
	get maneuverCode() {
		return this.maneuverForm.get("maneuverCode")!;
	}

	get PRO(): UntypedFormGroup {
		return this.maneuverForm.controls["PRO"] as UntypedFormGroup;
	}

	get COM(): UntypedFormGroup {
		return this.maneuverForm.controls["COM"] as UntypedFormGroup;
	}

	get LTW(): UntypedFormGroup {
		return this.maneuverForm.controls["LTW"] as UntypedFormGroup;
	}

	get PSD(): UntypedFormGroup {
		return this.maneuverForm.controls["PSD"] as UntypedFormGroup;
	}

	get FPA(): UntypedFormGroup {
		return this.maneuverForm.controls["FPA"] as UntypedFormGroup;
	}

	get FPM(): UntypedFormGroup {
		return this.maneuverForm.controls["FPM"] as UntypedFormGroup;
	}

	get SAW(): UntypedFormGroup {
		return this.maneuverForm.controls["SAW"] as UntypedFormGroup;
	}

	get WLM(): UntypedFormGroup {
		return this.maneuverForm.controls["WLM"] as UntypedFormGroup;
	}

	get KNO(): UntypedFormGroup {
		return this.maneuverForm.controls["KNO"] as UntypedFormGroup;
	}

	saveManeuver(value: string): void {
		this.maneuver.patchValue(value);
	}
}
